import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AlertDialogComponent} from "../app/peticiones/alert-dialog/alert-dialog.component";
import {Environment} from "@angular/cli/lib/config/workspace-schema";
import {environment} from "../environments/environment";
import {FuncionesExterno} from "../app/externo/funciones-Externo";

export class GestionesPeticiones {

    public static prefix:string  = "pge";

    gestion: string = "";

    peticion: number = 0;

    fecha?: Date;

    finalizado?: boolean;

    id?: number;


}
